import { loadGLightbox } from "common/glightbox-loader";
import { remoteImageStaticUrl } from "common/utils/remote-image";

import "./made-with-jiffy-section.scss";

const $getImages = () => document.querySelectorAll(".js-jiffytransfers-landing-v2-jiffy-image");

const loadImage = src =>
  new Promise(resolve => {
    const image = new Image();
    image.src = src;
    image.onload = () => resolve();
  });

const SWAP_IMAGE_INTERVAL = 3000;
const FADE_IN_CLASS = "jiffytransfers-landing-v2-made-with-jiffy-section__image--fade-in";
const FADE_OUT_CLASS = "jiffytransfers-landing-v2-made-with-jiffy-section__image--fade-out";

const IMAGE_PATHS = [
  "gen/jiffytransfers-landing-v2/made-with-jiffy/made-with-jiffy-1.png",
  "gen/jiffytransfers-landing-v2/made-with-jiffy/made-with-jiffy-2-alt.png",
  "gen/jiffytransfers-landing-v2/made-with-jiffy/made-with-jiffy-3.png",
  "gen/jiffytransfers-landing-v2/made-with-jiffy/made-with-jiffy-4.png",
  "gen/jiffytransfers-landing-v2/made-with-jiffy/made-with-jiffy-5.png",
  "gen/jiffytransfers-landing-v2/made-with-jiffy/made-with-jiffy-6.png",
  "gen/jiffytransfers-landing-v2/made-with-jiffy/made-with-jiffy-7.png",
  "gen/jiffytransfers-landing-v2/made-with-jiffy/made-with-jiffy-8.png",
  "gen/jiffytransfers-landing-v2/made-with-jiffy/made-with-jiffy-9.png",
  "gen/jiffytransfers-landing-v2/made-with-jiffy/made-with-jiffy-10.png",
  "gen/jiffytransfers-landing-v2/made-with-jiffy/made-with-jiffy-11.png",
  "gen/jiffytransfers-landing-v2/made-with-jiffy/made-with-jiffy-12.png",
  "gen/jiffytransfers-landing-v2/made-with-jiffy/made-with-jiffy-13.png",
  "gen/jiffytransfers-landing-v2/made-with-jiffy/made-with-jiffy-14.png",
  "gen/jiffytransfers-landing-v2/made-with-jiffy/made-with-jiffy-15.png",
  "gen/jiffytransfers-landing-v2/made-with-jiffy/made-with-jiffy-16.png",
  "gen/jiffytransfers-landing-v2/made-with-jiffy/made-with-jiffy-17.png",
  "gen/jiffytransfers-landing-v2/made-with-jiffy/made-with-jiffy-18.png",
  "gen/jiffytransfers-landing-v2/made-with-jiffy/made-with-jiffy-19.png",
  "gen/jiffytransfers-landing-v2/made-with-jiffy/made-with-jiffy-20.png"
];

const ALL_IMAGES = IMAGE_PATHS.map(path => remoteImageStaticUrl(path));
const IMGIX_PARAMS_FULL_IMAGE = "?ixlib=rb-0.3.5&auto=format";
const IMGIX_PARAMS_THUMBNAIL = "?ixlib=rb-0.3.5&auto=format&h=400&dpr=1.5&q=25";

let lightbox;
const currentImages = Array.from($getImages()).map($image => $image.src.split("?")[0]);
const otherImages = ALL_IMAGES.filter(image => !currentImages.includes(image));
const loadPromises = currentImages.map(image => loadImage(`${image}${IMGIX_PARAMS_THUMBNAIL}`));

const showLightbox = index => {
  lightbox?.openAt(index);
};

const swapRandomImage = () => {
  const previousImageIndex = Math.floor(Math.random() * currentImages.length);
  const newImageIndex = Math.floor(Math.random() * otherImages.length);

  const newImage = otherImages[newImageIndex];
  const newImageSrc = `${newImage}${IMGIX_PARAMS_THUMBNAIL}`;
  otherImages[newImageIndex] = currentImages[previousImageIndex];
  currentImages[previousImageIndex] = newImage;

  const promise = loadPromises[newImage] || (loadPromises[newImage] = loadImage(newImageSrc));

  return promise.then(() => {
    const $images = $getImages();
    const $imageToSwap = $images[previousImageIndex];
    $imageToSwap.classList.remove(FADE_IN_CLASS);
    $imageToSwap.classList.add(FADE_OUT_CLASS);
    $imageToSwap.src = newImageSrc;
    return new Promise(resolve =>
      // eslint-disable-next-line no-promise-executor-return
      setTimeout(() => {
        $imageToSwap.classList.remove(FADE_OUT_CLASS);
        $imageToSwap.classList.add(FADE_IN_CLASS);
        resolve();
      }, 300)
    );
  });
};

const initGLightbox = () => {
  const initializeGLightbox = () => {
    lightbox = window?.GLightbox({
      elements: ALL_IMAGES.map(image => ({
        href: `${image}${IMGIX_PARAMS_FULL_IMAGE}`,
        type: "image"
      })),
      touchNavigation: true,
      loop: false,
      autoplayVideos: false
    });
  };

  loadGLightbox(initializeGLightbox);
};

const initImageSwap = () => {
  Promise.all(loadPromises).then(() => {
    const swap = () => {
      setTimeout(async () => {
        await swapRandomImage();
        swap();
      }, SWAP_IMAGE_INTERVAL);
    };
    swap();
  });
};

document.addEventListener("DOMContentLoaded", () => {
  initGLightbox();
  $getImages().forEach(($image, index) => {
    $image.addEventListener("click", () => {
      const currentImage = currentImages[index];
      const imageIndex = ALL_IMAGES.indexOf(currentImage);
      if (imageIndex !== -1) {
        showLightbox(imageIndex);
      }
    });
  });

  initImageSwap();
});
